import { render } from "./ProfileManaged.vue?vue&type=template&id=432193ae&ts=true"
import script from "./ProfileManaged.vue?vue&type=script&lang=ts"
export * from "./ProfileManaged.vue?vue&type=script&lang=ts"

import exportComponent from "/Users/nicolacentonze/Desktop/Projects/cons-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__